import axios from "axios";
import useAuthStore from "stores/AuthStore/AuthStore";

const AXIOS_TIMEOUT = 100 * 1000; // 100 seconds
export const X_CHANNEL_ID = "WEB";

const API_ENDPOINTS = {
  PROD: "https://bff-service-1001923096385.asia-south1.run.app/",
  DEV: "https://bff-service-337976611558.us-central1.run.app",
  LOCAL: "http://localhost:3001/",
};

// BASE URL MAP
// Map frontend hostnames to the correct BFF base URL
const BASE_URI_MAP = {
  "community-portal-1001923096385.asia-south1.run.app": API_ENDPOINTS.PROD,
  "community-portal-337976611558.us-central1.run.app": API_ENDPOINTS.DEV,
  "community.weshoup.com": API_ENDPOINTS.PROD,
  localhost: API_ENDPOINTS.LOCAL,
};

export const hostName = window.location.hostname;

const api = axios.create({
  baseURL: BASE_URI_MAP[hostName],
  timeout: AXIOS_TIMEOUT,
});

// Note: 'origin' header cannot be set manually - browser sets it automatically
api.defaults.headers.common["x-channel-id"] = X_CHANNEL_ID;


// Request interceptor to add token dynamically
api.interceptors.request.use(
  (config) => {
    const token = useAuthStore.getState()?.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor to handle 401 errors
api.interceptors.response.use(
  (response) => {
    return Promise.resolve(response);
  },
  async (error) => {
    const { response } = error;
    const url = response?.config?.url;

    if (
      response?.status === 401 &&
      !url?.includes("login") &&
      !url?.includes("logout")
    ) {
      useAuthStore.getState().clearUserData();
      sessionStorage.clear();
      localStorage.clear();
      window.location.href = "/login";
    }

    return Promise.reject(error);
  },
);

export default api;
